import { render, staticRenderFns } from "./CrewLaborTemplate.vue?vue&type=template&id=0c328396"
import script from "./CrewLaborTemplate.vue?vue&type=script&lang=js"
export * from "./CrewLaborTemplate.vue?vue&type=script&lang=js"
import style0 from "./CrewLaborTemplate.vue?vue&type=style&index=0&id=0c328396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports